var _a;
import { IdLogging } from "./IdLogging";
export var LoggingStyles = (_a = {},
    _a[IdLogging.Default] = {
        background: "#666",
        color: "#fff",
    },
    _a[IdLogging.NetworkIn] = {
        background: "#009255",
        color: "#fff",
    },
    _a[IdLogging.NetworkOut] = {
        background: "#5627e4",
        color: "#fff",
    },
    _a[IdLogging.Graphics] = {
        background: "#da0943",
        color: "#fff",
    },
    _a[IdLogging.Animation] = {
        background: "#e47e00",
        color: "#fff",
    },
    _a[IdLogging.LandingPages] = {
        background: "#decf20",
        color: "#fff",
    },
    _a[IdLogging.Shop] = {
        background: "#0aadfb",
        color: "#fff",
    },
    _a[IdLogging.Sound] = {
        background: "#dbfb63",
        color: "#444",
    },
    _a[IdLogging.Store] = {
        background: "#B5C1FB",
        color: "#444",
    },
    _a[IdLogging.Tracking] = {
        background: "#fb6964",
        color: "#fff",
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/utils/logging/LoggingStyles.ts
// module id = 971
// module chunks = 3